module.exports = __webpack_public_path__ + "static/img/IMG_20151025_103515.b1d20194.jpg";